import Typography from 'Components/Base/Typography'
import React from 'react'
import { DashboardState } from 'reducers/dashboardSlice'
import { ScaleReading } from 'types/Dashboards'
import GridCard from '../../../DashboardGlucosePage/components/GridCard'

interface Props {
  scaleReadings: ScaleReading[]
  scaleReadingsSummary: DashboardState
  hasBodyComposition: boolean
}
export default function GridCards({ scaleReadings, scaleReadingsSummary, hasBodyComposition }: Props) {
  return (
    <>
      <div
        className="scale-grid-template"
        style={{
          display: 'grid',
          marginBottom: 25,
        }}
      >
        <GridCard title={`${scaleReadings[scaleReadings.length - 1].value} lbs`} subtitle="Current Weight" />
        <GridCard title={`${scaleReadings[0].value} lbs`} subtitle="Starting Weight" />
        <GridCard
          title={`${scaleReadingsSummary.goalWeight === '0' || scaleReadingsSummary.goalWeight === '' ? 'N/A' : scaleReadingsSummary.goalWeight}`}
          subtitle="Goal Weight"
        />
        <GridCard title={`${Math.round(scaleReadingsSummary.bmi * 10) / 10}`} subtitle="Current BMI" />
        {hasBodyComposition && (
          <>
            <GridCard
              title={
                scaleReadings[scaleReadings.length - 1].bodyFatPercent
                  ? `${scaleReadings[scaleReadings.length - 1].bodyFatPercent} %`
                  : 'No Data Received'
              }
              subtitle="Fat %"
              info
              infoHTML={
                <div style={{ textAlign: 'left', padding: '15px 10px' }}>
                  <Typography size={24} variant="h3" styles={{ marginBottom: 20 }}>
                    What is a healthy body fat percentage?
                  </Typography>

                  <Typography size={18} styles={{ marginBottom: 20 }}>
                    A healthy body fat percentage varies by sex and typically falls within these commonly accepted ranges:
                  </Typography>
                  <ul>
                    <li>
                      <Typography size={18}>
                        <b>Men:</b> about 5-25%
                      </Typography>
                    </li>
                    <li>
                      <Typography size={18}>
                        <b>Women:</b> about 12-32%
                      </Typography>
                    </li>
                  </ul>
                </div>
              }
            />
            <GridCard
              title={
                scaleReadings[scaleReadings.length - 1].musclePercent
                  ? `${scaleReadings[scaleReadings.length - 1].musclePercent} %`
                  : 'No Data Received'
              }
              subtitle="Muscle %"
              info
              infoHTML={
                <div style={{ textAlign: 'left', padding: '15px 10px' }}>
                  <Typography size={24} variant="h3">
                    What is a healthy muscle mass percentage?
                  </Typography>

                  <Typography size={18} styles={{ margin: '15px 0px' }}>
                    A healthy muscle mass percentage varies by sex and age, and typically falls within these commonly accepted ranges:
                  </Typography>
                  <table style={{ border: '1px solid black', textAlign: 'center' }}>
                    <thead style={{ backgroundColor: '#d8eef3' }}>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>Age</Typography>
                        </th>
                        <th style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>Women</Typography>
                        </th>
                        <th style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>Men</Typography>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>20–39</Typography>
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>63–75.5%</Typography>
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>74–89%</Typography>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>40–59</Typography>
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>62–73.5%</Typography>
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>73–86%</Typography>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>60–79</Typography>
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>60–72.5%</Typography>
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px 18px' }}>
                          <Typography size={18}>70–84%</Typography>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              }
            />
            <GridCard
              title={
                scaleReadings[scaleReadings.length - 1].waterPercent
                  ? `${scaleReadings[scaleReadings.length - 1].waterPercent} %`
                  : 'No Data Received'
              }
              subtitle="Water %"
              info
              infoHTML={
                <div style={{ textAlign: 'left', padding: '15px 10px' }}>
                  <Typography size={24} variant="h3">
                    What is body water percentage and why does it matter?
                  </Typography>

                  <Typography size={18} styles={{ margin: '15px 0px' }}>
                    Body water composition is the percentage of your body made up of water, which typically accounts for{' '}
                    <b>about 50–65% of an adult’s body weight</b> and is essential for functions like temperature regulation, nutrient transport,
                    waste removal, and organ support.{' '}
                  </Typography>
                  <Typography size={18}>
                    Maintaining proper hydration helps keep organs functioning well, supports healthy metabolism, and contributes to overall
                    well-being
                  </Typography>
                </div>
              }
            />
            <GridCard
              icon={scaleReadings[scaleReadings.length - 1].value - scaleReadings[0].value >= 0 ? 'arrow-up' : 'arrow-down'}
              title={`${Math.abs(scaleReadings[0].value - scaleReadings[scaleReadings.length - 1].value)} lbs`}
              subtitle={`Weight Change - All Readings`}
            />
          </>
        )}
      </div>
    </>
  )
}
